import { apiSlice } from "../../app/api/apiSlice";

export const facilityApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getFacilityTypes: builder.query({
      query: () => ({
        url: "/community/facility-types",
        method: "GET",
      }),
    }),
    fetchFacilityById: builder.mutation({
      query: (credentials) => ({
        url: `/facility/${credentials}`,
        method: "GET",
      }),
    }),
    fetchFacilityPatients: builder.mutation({
      query: (credentials) => ({
        url: `/facility/patients/${credentials}`,
        method: "GET",
      }),
    }),
    fetchFacilityStaff: builder.mutation({
      query: (credentials) => ({
        url: `/facility/staffs/${credentials}`,
        method: "GET",
      }),
    }),
    fetchFacilityProviders: builder.mutation({
      query: (credentials) => ({
        url: `/facility/providers/${credentials}`,
        method: "GET",
      }),
    }),
    createFacility: builder.mutation({
      query: (credentials) => ({
        url: `/facility/`,
        method: "POST",
        body: credentials,
      }),
    }),
    updateFacility: builder.mutation({
      query: (credentials) => ({
        url: `/facility/${credentials.id}`,
        method: "PATCH",
        body: credentials,
      }),
    }),
    deleteFacility: builder.mutation({
      query: (credentials) => ({
        url: `/facility/${credentials?.id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetFacilityTypesQuery,
  useFetchFacilityByIdMutation,
  useFetchFacilityPatientsMutation,
  useFetchFacilityStaffMutation,
  useFetchFacilityProvidersMutation,
  useCreateFacilityMutation,
  useUpdateFacilityMutation,
  useDeleteFacilityMutation,
} = facilityApiSlice;
